exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".App{text-align:left;position:relative;height:100%}\n", "",{"version":3,"sources":["C:\\GithubRepositories\\TPack/src\\App.scss"],"names":[],"mappings":"AACA,KACE,eAAgB,CAChB,iBAAkB,CAClB,WAAY","file":"App.scss","sourcesContent":["\r\n.App {\r\n  text-align: left;  \r\n  position: relative;\r\n  height: 100%;\r\n}\r\n"]}]);

